import capitalize from 'lodash-es/capitalize';

import { SupportedModel, SupportedModelDisplayName } from './pages/live-ai-models-and-presets-page/interfaces';

const MODEL_TYPE_DISPLAY_NAMES: SupportedModelDisplayName = {
  [SupportedModel.YoloX]: 'VI object detection', // @TODO: remove this when YoloX is removed
  [SupportedModel.CustomObjectDetection]: 'OV detector',
  [SupportedModel.CustomSituation]: 'Situation detection',
  [SupportedModel.ObjectDetection]: 'VI object detection'
};

export function getModelTypeDisplayName(modelType: SupportedModel): string {
  return MODEL_TYPE_DISPLAY_NAMES[modelType];
}

export function getInsightKey(insightName: string, modelType: SupportedModel): string {
  return modelType === SupportedModel.CustomObjectDetection || modelType === SupportedModel.CustomSituation
    ? `${insightName.toLowerCase()}-${modelType.toLowerCase()}`
    : insightName.toLowerCase();
}

export function formatInsightName(insightName: string, modelType: SupportedModel, withCustomBadge: boolean = true): string {
  const isCustomModel = modelType === SupportedModel.CustomObjectDetection || modelType === SupportedModel.CustomSituation;

  if (isCustomModel) {
    return withCustomBadge ? `${insightName} (custom)` : insightName;
  }

  return capitalize(insightName);
}
